<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：会员-积分管理-邀请送积分
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="是否开启邀请送积分：" >
        <el-radio-group v-model="form.is_direct_recommend" >
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
	    </el-form-item>
      <el-form-item label="邀请送积分：">
        <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance">添加</el-button>
        <div class="gray9">当邀请送积分开启时，会员等级不可为空、不可重复</div>
        <div class="gray9">邀请送积分开启时，会员等级与设置的会员等级一致的用户邀请的人数大于或等于邀请送积分门槛时可获得相应档位的积分</div>
        <div class="gray9">只有用户邀请并下单的下级用户才能算用户的邀请人数</div>
        <table border="0" cellpadding="2" cellspacing="5" class="mt30">
          <tr>
            <th class="tl" style="width: 200px">会员等级</th>
            <th class="tl" style="width: 150px">邀请送积分门槛(人)</th>
            <th class="tl" style="width: 150px">获取积分</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in form.DirectRecommend" :key="index">
            <td>
              <el-select v-model="item.grade_id" placeholder="请选择">
                <el-option v-for="(value,key) in gradeList" :key="key" :label="value.name"  :value="value.grade_id">
                </el-option>
              </el-select>
            </td>
            <td><el-input size="small" v-model="item.number" min="1" type="number" placeholder="请输入邀请送积分门槛"></el-input></td>
            <td><el-input size="small" v-model="item.point" min="0" type="number" placeholder="请输入获取积分"></el-input></td>
            <td><el-button size="small" @click="delPerformance(index)">删除</el-button></td>
          </tr>
        </table>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import PointsApi from '@/api/points.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          is_direct_recommend: 0,
          DirectRecommend:[],
        },
        /*加载完成*/
        loading: false,
        gradeList:[],

      };
    },
    props: {
      settingData: Object
    },
    created() {
      this.getData();
    },

    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        self.loading = true;
        let Params = {};
        PointsApi.getDirectRecommend(Params, true).then(data => {
          self.loading = false;
          self.form = data.data.values;
          self.form.DirectRecommend = (self.form.DirectRecommend.length > 0) ? self.form.DirectRecommend : [{'grade_id':'', 'number':0, 'point':0}];
          self.gradeList = data.data.gradeList;
        }).catch(error => {
          self.loading = false;
        });
      },

      AddPerformance(){
        let self = this;
        let data = {'grade_id':'', 'number':0, 'point':0};
        self.form.DirectRecommend.push(data);
      },
      delPerformance(key){
        let self = this;
        let DirectRecommend = self.form.DirectRecommend;
        let newdata = [];
        DirectRecommend.forEach((item,index)=>{
          if(index != key){
            newdata.push(item);
          }
        });
        self.form.DirectRecommend = newdata;
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        PointsApi.setDirectRecommend(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
  .max-w300 {
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/points/part/DirectRecommend.vue